import { ref } from '@vue/composition-api'
import { STORE_MODULE_NAME } from "./pillarStoreModule";

export default function usePillar() {

    // Table Handlers
  const tableColumns = ref([
      { key: 'pillar',
        label: 'опора',
      },
      { key: 'platform',
        label: 'платформа',
      },
      { key: 'station',
        label: 'станция',
      },
      { key: 'railway_sector',
        label: 'сектор',
      },
      { key: 'user',
        label: 'пользователь',
      },
  ])

  const setupData = {
      formModel: {
          number: '',
          object_type:'',
          railway_sector:'',
          station:'',
          platform:'',
          user: '',
          geolocation: {
              point: {
                  lat: null,
                  long: null
              },
              geo_addition: {
                  picket: null,
                  km: null,
                  path: null
              }
          }
      },
  }

  const addDataUrl = `${STORE_MODULE_NAME}/create`
  const fetchDataUrl = `${STORE_MODULE_NAME}/fetch`

  return {

    addDataUrl,
    fetchDataUrl,

    tableColumns,
    setupData,
  }
}
